// extracted by mini-css-extract-plugin
module.exports = {"Background":"Background_Background__3pl6y"};